<h2 mat-dialog-title>Uzupełnianie kwoty</h2>

<form (ngSubmit)="save()">
  <mat-dialog-content>
    <div class="flex flex-col align-stretch justify-start">
      <div class="mb-16">
        <span class="label">Dostawca:</span>
        <span class="value">{{ liability.billerName }}</span>
      </div>

      <div class="mb-16">
        <span class="label">Numer konta:</span>
        <span class="value">{{ liability.bban }}</span>
      </div>
      <div class="mb-16">
        <span class="label">Termin płatności:</span>
        <span class="value">{{ liability.paymentDue | date: defaultPatternWithTime }}</span>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Kwota płatności</mat-label>
        <input matInput [formControl]="amount" required appCurrency />
        <mat-error>
          <app-amount-error
            [amount]="amount"
            [minAmount]="MIN_AMOUNT"
            [maxAmount]="this.appConfig.config.liabilityAmountLimit"
          ></app-amount-error>
        </mat-error>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="start">
    <button mat-raised-button type="submit" color="accent" [disabled]="amount.invalid" cdkFocusInitial>Zapisz</button>
    <button mat-button [matDialogClose]="false">Anuluj</button>
  </mat-dialog-actions>
</form>
